import React, { Dispatch, useEffect, useState } from "react";
import Shadow from "../Shadow";
import CheckBox from "../forms/CheckBox";
import { change, Field } from "redux-form";
import { requiredField } from "../validators/validators";
import { Input } from "../forms/FormControls";
import { ChoseRecord } from "../CalcForm";
import { IAdditional, IAdditionalChoise } from "../../../types";

interface IAddCb {
  uncheck: boolean;
  hasDepth: string;
  hasView: string;
  dispatch: (v) => void;
  setAdditionalChoose: (v: (chosen: ChoseRecord) => ChoseRecord) => ChoseRecord;
  data: IAdditional;
}

const AddRadioBox = ({
  setAdditionalChoose,
  name,
  price,
  value,
  id,
  func = undefined,
  txt = "",
}: Record<string, any> & {
  setAdditionalChoose: (v: (chosen: ChoseRecord) => ChoseRecord) => ChoseRecord;
}) => {
  const handleClick = (v) => {
    setAdditionalChoose((chosen) => ({
      ...chosen,
      [name]: v.target?.value
        ? {
            selected: v.target?.value,
            type: "mul",
            price,
          }
        : undefined,
    }));
    func?.();
  };
  return (
    <div className="calc_checker_box2_special">
      <div className="calc_checker_box2_special_inner">
        <Field
          className="calc_checker_special"
          component={"input"}
          value={value}
          onClick={handleClick}
          name={name + "_Значение"}
          id={id + "_Значение"}
          type={"radio"}
        />
        <label className="calc_checker_text_special" htmlFor={id + "_Значение"}>
          {txt}
        </label>
      </div>
    </div>
  );
};
const AdditionalRadiBox = ({
  setAdditionalChoose,
  data,
  name,
  reload = null,
}) => {
  return (
    <div className="additionalBtnsFlex">
      {(data as IAdditionalChoise[]).map((el) => {
        return (
          <AddRadioBox
            setAdditionalChoose={setAdditionalChoose}
            func={reload}
            key={el.name}
            name={name}
            price={el.defaultPrice}
            value={el.name}
            id={"down_radio_" + el.name}
            txt={el.name}
          />
        );
      })}
    </div>
  );
};
const NumberInput = ({
  data,
  value,
  setSecondSelect,
  setAdditionalChoose,
}: {
  data: IAdditional;
  value: string;
  setSecondSelect: Dispatch<(prevState: undefined) => undefined>;
  setAdditionalChoose: (v: (chosen: ChoseRecord) => ChoseRecord) => ChoseRecord;
}) => {
  const handleInput = (v) => {
    setSecondSelect(v.target?.value);
    setAdditionalChoose((chosen) => ({
      ...chosen,
      [data.name]: v.target?.value
        ? {
            selected: v.target?.value,
            type: "add",
            price: v.target?.value * data.defaultPrice,
          }
        : undefined,
    }));
  };

  return (
    <div className="calc_form_for_form">
      <Field
        className="calc_input_form"
        value={value}
        onChange={handleInput}
        validate={requiredField}
        step={"1"}
        min={"1"}
        component={Input}
        placeholder={"Количество"}
        name={data.name + "_Значение"}
        id={data.name + "_Значение"}
        type={"number"}
      />
    </div>
  );
};
const AddCheckBox = ({
  hasView,
  dispatch,
  hasDepth,
  uncheck,
  data,
  setAdditionalChoose,
}: IAddCb) => {
  const [check, setCheck] = useState(false);
  const notShowed = data.additional_choises.some(
    (el) => el.additional_prices.length,
  );
  const [secondSelect, setSecondSelect] = useState();

  const handleCheck = (v: boolean) => {
    setCheck(v);
    if (v && data.additional_choises.length) {
      const view = data.additional_choises.find((el) => el.name === hasView);
      if (view) {
        const depth = view.additional_prices.find(
          (el) => el.millimetre.toString() === hasDepth,
        );
        const price = depth.price;
        setAdditionalChoose((chosen) => ({
          ...chosen,
          [data.name]: {
            type: "mul",
            selected: data.name,
            price: price,
          },
        }));
      }
    } else {
      setSecondSelect(undefined);
      setAdditionalChoose((chosen) => ({
        ...chosen,
        [data.name]: undefined,
      }));
      dispatch(change("calc", data.name, undefined));
      dispatch(change("calc", data.name + "_Значение", undefined));
    }
  };
  useEffect(() => {
    handleCheck(false);
  }, [uncheck]);
  return (
    <>
      <CheckBox
        onCheck={(v) => handleCheck(v)}
        info={{ text: data.description, img: data.image }}
        name={data.name}
        txt={data.name}
      />
      {check &&
        !notShowed &&
        (data.numberInput ? (
          <NumberInput
            value={secondSelect}
            setSecondSelect={setSecondSelect}
            setAdditionalChoose={setAdditionalChoose}
            data={data}
          />
        ) : (
          <AdditionalRadiBox
            setAdditionalChoose={setAdditionalChoose}
            name={data.name}
            data={data.additional_choises.map((el) => el)}
          />
        ))}
    </>
  );
};

const Additionally = ({
  uncheck,
  setAdditionalChoose,
  additionally,
  dispatch,
  hasView,
  hasDepth,
  hasMaterial,
  shadow,
  hasFormat,
}) => {
  const [additionalState, setAdditionalState] = useState([] as IAdditional[]);
  useEffect(() => {
    setAdditionalState(
      (additionally as IAdditional[]).filter((a) => {
        // проверка на ограничения (если есть ограничения, то проверка, что выбор соответствует ограничению)
        if (hasMaterial) {
          if (a.types.length && !a.types.some((el) => el.name === hasMaterial))
            return false;
          if (hasView) {
            const addChoicesLen = !!a.additional_choises?.length;
            // проверка на наличие ограничений на вид
            if (addChoicesLen) {
              const choicesWithViews = a.additional_choises.filter(
                (el) =>
                  !el.views.length ||
                  el.views.some((el) => el.name === hasView),
              );
              if (!choicesWithViews.length) return false;
              if (
                hasDepth &&
                addChoicesLen &&
                !choicesWithViews.some(
                  (choice) =>
                    !choice.additional_prices?.length ||
                    choice.additional_prices.some(
                      (price) => price.millimetre == hasDepth,
                    ),
                )
              )
                return false;
            }
            if (
              hasFormat &&
              a.formats.length &&
              !a.formats.some((el) => el.name === hasFormat)
            )
              return false;
          }
        }
        return true;
      }),
    );
  }, [hasMaterial, hasFormat, hasView, hasDepth, additionally]);

  return (
    <div className={"bl_4_grid_item"}>
      {shadow && <Shadow />}
      <div className="calc_title_box">
        <div className="calc_title">Дополнительно</div>
        {additionalState.map((el) => (
          <AddCheckBox
            dispatch={dispatch}
            hasView={hasView}
            hasDepth={hasDepth}
            uncheck={uncheck}
            key={el.name}
            setAdditionalChoose={setAdditionalChoose}
            data={el}
          />
        ))}
      </div>
    </div>
  );
};
export default Additionally;
